export const MAX_BLINK_MEDIA_IN_PRODUCT = 1;

export const MAX_MEDIA_IN_PRODUCT = 100;

//hardcoded values according to the designs
export const productCardMinWidth = 202;
export const productCardAddedHeight = 55;
export const productCardHeightMultiplier = 0.67;
export const productRowMinHeight = 80;
